module.exports = __webpack_public_path__ + "static/hotblack-coffee-about2-6d9ba238d171397fa9b8c8492e0d3db6.png";